import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useUserStore = create()(
    persist(
        (set) => ({
            refetchUsers: false,
            storeRefetchUsers: (refetchUsers) => set(() => ({ refetchUsers: refetchUsers })),
            query: getInitialQuery(),
            storeQuery: (query) => set(() => ({ query: query }))
        }),
        {
            name: 'user-storage'
        }
    )
);

export default useUserStore;